module.exports = __webpack_public_path__ + "img/2012-12-14 18.22.58.f1840074.jpg";